import { ReactElement } from "react";
import {
	UiComponentBuildContext,
	UiComponentBuilder,
} from "@animech/axiom-ui-builder";
import { Root } from "@definitions";
import { AccordionGroupNode } from "src/definitions/ui-definitions";
import { AccordionGroup } from "src/ui/components";

export class AccordionGroupComponentBuilder
	implements UiComponentBuilder<Root, AccordionGroupNode>
{
	constructor() {}

	public build(
		node: AccordionGroupNode,
		context: UiComponentBuildContext<Root>,
	) {
		return this._render(node, context);
	}

	private _render(
		node: AccordionGroupNode,
		context: UiComponentBuildContext<Root>,
	): ReactElement {
		return (
			<AccordionGroup id={node.id}>{context.childElements}</AccordionGroup>
		);
	}
}
